import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Location } from 'history'
import Button, { ButtonProps } from '@mui/material/Button'
import ArrowBack from '@mui/icons-material/ArrowBack'

interface BackButtonprops extends ButtonProps<typeof Link> {
  children: string
}

export function BackButton({ children, ...props }: BackButtonprops) {
  const { t, i18n } = useTranslation()

  const content = i18n.exists(children) ? t(children) : children

  return (
    <Button component={Link} {...props}>
      {content}
    </Button>
  )
}

BackButton.defaultProps = {
  children: 'Form.Buttons.Back',
  color: 'primary',
  variant: 'text',
  startIcon: <ArrowBack />,
  to: (location: Location) => location.pathname.split('/').slice(0, -1).join('/')
}

type SegmentsRange = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8

export function goPathSegmentsBack(amountOfSegments: SegmentsRange = 1) {
  const to = (location: Location) => {
    return location.pathname.split('/').slice(0, -amountOfSegments).join('/')
  }
  return to
}
